import { apiGet, apiPost, apiPut, apiDelete } from "../../utils/apiHelpers";

// fetch framework
export const fetchPackages = async () => {
  try {
    let response = await apiGet(`/admin/packages`, {});

    if (response.error) {
      throw response.data.response.status === 500
        ? new Error("")
        : response.data;
    }
    return response.data.data;
  } catch (err) {
    throw err;
  }
};

export const fetchSinglePackage = async (params) => {
  const [id] = params.queryKey;
  try {
    let response = await apiGet(`/admin/packages/${id}`, {});

    if (response.error) {
      throw response.data.response.status === 500
        ? new Error("")
        : response.data;
    }
    return response.data;
  } catch (err) {
    throw err;
  }
};

export const createPackage = async (formData) => {
  try {
    let response = await apiPost(`/admin/packages`, formData, {});

    if (response.error) {
      throw response.data.response.status === 500
        ? new Error("")
        : response.data;
    }
  } catch (err) {
    console.log({ err });
    throw err;
  }
};

export const editPackage = async (data) => {
  try {
    let response = null;
    const { packageId, payload } = data;
    if (data) {
      response = await apiPut(`/admin/packages/${packageId}`, payload);
    }
    if (response.error) {
      throw response.data.response.status === 500
        ? new Error("")
        : response.data;
    }
  } catch (error) {
    console.log({ error });
    throw error;
  }
};

export const deletePackage = async (id) => {
  try {
    let response = await apiDelete(`/admin/packages/${id}`);
    if (response.error) {
      throw response.data.response.status === 500
        ? new Error("")
        : response.data;
    }
  } catch (err) {
    console.log({ err });
    throw err;
  }
};
